import tpl from './templates';

// To more readable code, try to use keys in alphabet order " { ab_bc_de: abBcDe }"
// body country city drive engine gearbox generation isNew location make makeTranslate model year
export const AVTO = {
  city: tpl.city,
  // city: tpl.city,
  make: tpl.make,
  country: tpl.country,
  body: tpl.body,
  engine: tpl.engine,
  gearbox: tpl.gearbox,
  year: tpl.year,

  // 2
  make_model: tpl.makeModel,
  country_make: tpl.makeCountry,
  city_make: tpl.makeCity,
  body_isnew: tpl.bodyIsnew,
  body_city: tpl.bodyCity,
  gearbox_isnew: tpl.gearboxIsnew,
  city_gearbox: tpl.gearboxCity,
  city_year: tpl.cityYear,
  body_year: tpl.bodyYear,

  city_engine: tpl.cityEngine,
  body_make: tpl.makeBody,
  engine_make: tpl.makeEngine,
  gearbox_make: tpl.makeGearbox,
  isnew_year: tpl.isnewYear,
  city_isnew: tpl.cityIsnew,
  


  // 3
  gearbox_isnew_make: tpl.makeGearboxIsnew,
  city_gearbox_isnew: tpl.gearboxIsnewCity,
  city_gearbox_make: tpl.makeGearboxCity,
  engine_make_model: tpl.engineMakeModel,
  body_make_model: tpl.bodyMakeModel,
  body_isnew_make: tpl.bodyIsnewMake,
  body_isnew_year: tpl.bodyIsnewYear,
  country_make_model: tpl.countryMakeModel,
  body_city_isnew: tpl.bodyCityIsnew,
  body_city_make: tpl.bodyCityMake,
  body_city_year: tpl.bodyCityYear,
  city_engine_year: tpl.cityEngineYear,
  make_model_year: tpl.makeModelYear,
  city_make_model: tpl.makeModelCity,
  gearbox_make_model: tpl.gearboxMakeModel,
  city_isnew_year: tpl.cityIsnewYear,

  // 4
  city_gearbox_isnew_make: tpl.cityGearboxIsnewMake,
  city_engine_make_model: tpl.makeModelEngineCity,
  city_gearbox_make_model: tpl.cityGearboxMakeModel,
  body_city_make_model: tpl.bodyCityMakeModel,
  body_city_isnew_make: tpl.bodyCityIsnewMake,
  city_make_model_year: tpl.cityMakeModelYear,
  body_isnew_make_model: tpl.bodyIsnewMakeModel,

  // 5
  city_engine_make_model_year: tpl.makeModelEngineCityYear,
  body_city_isnew_make_model: tpl.bodyCityIsnewMakeModel,

  body_city_isnew_year: tpl.bodyCityIsnewYear,
  city_engine_isnew_year: tpl.cityEngineIsnewYear,
  isnew_year: tpl.isnewYear,
  city_isnew_year: tpl.cityIsnewYear,
  city_isnew: tpl.cityIsnew,
  isnew_make_model_year: tpl.isnewMakeModelYear,
  city_isnew_make_model_year: tpl.cityIsnewMakeModelYear,
  gearbox_isnew_make_model: tpl.gearboxIsnewMakeModel,
  city_gearbox_isnew_make_model: tpl.cityGearboxIsnewMakeModel,
  engine_isnew_make_model: tpl.engineIsnewMakeModel,
  city_engine_isnew_make_model: tpl.cityEngineIsnewMakeModel,
/*   body_isnew_make_model: tpl.bodyIsnewMakeModel,
  body_city_isnew_make_model: tpl.bodyCityIsnewMakeModel, */
  country_isnew_make_model: tpl.countryIsnewMakeModel,
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/search/avto/index.js